/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSportsBarIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sports-bar"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.2 19.15L5.2 12.5Q3.85 12.1 3.02 10.95Q2.2 9.8 2.2 8.32Q2.2 6.83 3.09 5.66Q3.98 4.5 5.33 4Q5.97 2.73 7.21 1.96Q8.45 1.2 9.95 1.2Q10.88 1.2 11.68 1.5Q12.47 1.8 13.13 2.33Q13.35 2.27 13.57 2.25Q13.8 2.23 14.05 2.23Q15.97 2.23 17.32 3.58Q18.68 4.92 18.68 6.83Q18.68 7.3 18.56 7.72Q18.45 8.15 18.25 8.55L19.15 8.55Q20.32 8.55 21.06 9.32Q21.8 10.1 21.8 11.2L21.8 16.2Q21.8 17.32 21.04 18.09Q20.27 18.85 19.15 18.85L17.65 18.85L17.65 19.15Q17.65 20.27 16.89 21.04Q16.13 21.8 15 21.8L7.85 21.8Q6.72 21.8 5.96 21.04Q5.2 20.27 5.2 19.15ZM4.85 8.32Q4.85 9.05 5.38 9.56Q5.9 10.07 6.63 10.07Q7.38 10.07 7.94 9.63Q8.5 9.18 9.2 8.45Q10.03 7.58 10.85 7.04Q11.68 6.5 13.03 6.5L15.9 6.5Q15.85 5.85 15.3 5.36Q14.75 4.88 14 4.88Q13.35 4.88 12.89 5.03Q12.43 5.17 12.28 5.28L11.32 4.45Q11.07 4.25 10.7 4.05Q10.32 3.85 9.78 3.85Q9.07 3.85 8.47 4.22Q7.88 4.6 7.55 5.28L7.17 6.17L6.15 6.55Q5.58 6.75 5.21 7.25Q4.85 7.75 4.85 8.32ZM17.65 16.2L19.15 16.2Q19.15 16.2 19.15 16.2Q19.15 16.2 19.15 16.2L19.15 11.2Q19.15 11.2 19.15 11.2Q19.15 11.2 19.15 11.2L17.65 11.2Z" fill={color} />
    </svg>
  );
}
